export const exportToCSV = (data, filename = 'export') => {
  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  const headers = Object.keys(data[0]);
  const rows = data.map(row => 
    headers.map(header => {
      let value = row[header] || '';
      // Convert to string and handle special characters
      value = String(value);
      // Escape quotes and handle commas
      if (value.includes(',') || value.includes('"') || value.includes('\n')) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    }).join(',')
  );
  
  // Add UTF-8 BOM for proper encoding in Excel
  const csv = '\uFEFF' + [headers.join(','), ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Export as JSON (UTF-8)
export const exportToJSON = (data, filename = 'export') => {
  const json = JSON.stringify(data, null, 2);
  const blob = new Blob([json], { type: 'application/json;charset=utf-8' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.json`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Export as Excel (CSV with UTF-8 BOM)
export const exportToExcel = (data, filename = 'export') => {
  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  const headers = Object.keys(data[0]);
  const rows = data.map(row => 
    headers.map(header => {
      let value = row[header] || '';
      value = String(value);
      if (value.includes(',') || value.includes('"') || value.includes('\n')) {
        return `"${value.replace(/"/g, '""')}"`;
      }
      return value;
    }).join(',')
  );
  
  // Add UTF-8 BOM for Excel
  const csv = '\uFEFF' + [headers.join(','), ...rows].join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.xls`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Export as PDF (HTML format for printing)
export const exportToPDF = (data, title = 'Report', filename = 'report') => {
  const headers = Object.keys(data[0] || {});
  
  const html = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>${title}</title>
      <meta charset="UTF-8">
      <style>
        body { font-family: Arial, sans-serif; padding: 20px; }
        h1 { color: #0f1f3d; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th { background: #0f1f3d; color: white; padding: 10px; text-align: left; }
        td { padding: 10px; border-bottom: 1px solid #ddd; }
        tr:nth-child(even) { background: #f9f9f9; }
        .meta { margin-top: 20px; color: #666; font-size: 12px; }
        .currency { font-weight: bold; color: #0f1f3d; }
      </style>
    </head>
    <body>
      <h1>${title}</h1>
      <p>Exported: ${new Date().toLocaleString()}</p>
      <table>
        <thead>
          <tr>${headers.map(h => `<th>${h}</th>`).join('')}</tr>
        </thead>
        <tbody>
          ${data.map(row => `
            <tr>${headers.map(h => `<td>${row[h] || ''}</td>`).join('')}</tr>
          `).join('')}
        </tbody>
      </table>
      <div class="meta">Generated by FaithConnect SMS Platform</div>
    </body>
    </html>
  `;
  
  const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.html`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Format data for export
export const formatForExport = (data, fields) => {
  if (!data || data.length === 0) return [];
  
  return data.map(item => {
    const formatted = {};
    fields.forEach(field => {
      if (field.key in item) {
        let value = item[field.key];
        // Handle special characters
        if (typeof value === 'string') {
          // Preserve special characters like ₵ and —
          value = value.replace(/—/g, '—').replace(/₵/g, '₵');
        }
        formatted[field.label] = value;
      }
    });
    return formatted;
  });
};

// Get current date for filename
export const getExportFilename = (prefix) => {
  const date = new Date();
  const timestamp = date.toISOString().slice(0, 10);
  return `${prefix}_${timestamp}`;
};

// Clean text for export
export const cleanTextForExport = (text) => {
  if (!text) return '';
  return String(text)
    .replace(/—/g, '—') // Keep em dash
    .replace(/₵/g, '₵') // Keep Ghana Cedi
    .replace(/"/g, '""') // Escape quotes
    .trim();
};